import * as React from 'react';
import svgSrc from 'assets/product-day.svg';

export const ProductDay = props => (
  <figure {...props}>
    <img src={svgSrc} alt="Product of the day" />
  </figure>
);
